import { TFunction } from 'react-i18next';
import { formatDate } from 'shared/util/utility';
import { PromotionPickerThemeType, ResolveSelectedPromotionType } from './PromotionPicker.types';
export const promotionPickerTheme = (type: 'green' | 'theme'): PromotionPickerThemeType => {
	if (type === 'green') {
		return {
			inputColor: 'green',
			textColor: 'text-white',
			textBlackColor: 'text-white',
			textGrayColor: 'text-gray-200',
			gradientFrom: 'from-primary-400 dark:from-dark-100',
			promotionCard: 'bg-primary-500 dark:bg-dark-300 to-transparent',
			iconSpinner: 'text-primary-100 [&>circle]:stroke-primary-500 dark:text-primary-100 dark:[&>circle]:stroke-dark-300',
			iconInput: ' stroke-primary-500 dark:stroke-gray-100',
			inputUseColor: 'text-primary-100',
			marquee: 'dark:from-dark-300',
		};
	}
	return {
		inputColor: 'theme',
		textColor: 'text-primary-500 dark:text-gray-100',
		textBlackColor: 'text-gray-900  dark:text-gray-100',
		textGrayColor: 'text-gray-700 dark:text-gray-400',
		gradientFrom: ' to-transparent from-white dark:from-dark-200 ',
		promotionCard: 'border-2 border-gray-100 dark:border-0 dark:bg-dark-300',
		iconSpinner: 'text-primary-400 [&>circle]:stroke-gray-100 dark:text-primary-100 dark:[&>circle]:stroke-dark-300',
		iconInput: 'text-primary-500 dark:text-gray-100',
		inputUseColor: 'text-primary-400 dark:text-primary-100',
		marquee: 'from-white dark:from-dark-300',
	};
};

export const resolveSelectedPromotion = ({ initialPromotion, promotionWithCode, fetchedPromotions }: ResolveSelectedPromotionType) => {
	if (initialPromotion?.id) {
		return { id: initialPromotion?.id, name: initialPromotion?.name };
	} else if (promotionWithCode) {
		return { id: promotionWithCode.promotionId, name: promotionWithCode.promotionName };
	} else if (fetchedPromotions.length) {
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		return { id: fetchedPromotions[0]!.promotionId, name: fetchedPromotions[0]!.promotionName };
	} else {
		return { id: '', name: '' };
	}
};

export const promotionDateTill = (registrationDateTill: string | null, t: TFunction) => {
	if (!registrationDateTill || registrationDateTill === '3100-01-01T00:00:00.000Z') return t('regPromotionPickerPromotionAvailable');
	else return t('regPromotionPickerPromotionAvailableTo') + ' ' + formatDate(registrationDateTill, 'YYYY-MM-DD HH:mm');
};
